import { Button, Flex, FormControl, FormErrorMessage, FormLabel, Input, Text } from '@chakra-ui/react'
import axios from 'axios';
import { Props } from 'framer-motion/types/types'
import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { getSubmittedAssignments, gradeAssignment } from '../../../action/teacherAction';
import { useStudentAuthDispatch, StateType } from '../../../store/store';

function GradeAssignment({ match }: Props) {
  const dispatch = useStudentAuthDispatch();
  const { data: { token }, submittedAssignments } = useSelector((state: StateType) => state.rootReducer.teacherReducer);
  const teacherToken = token.slice(17, (token.length - 2));
  console.log(window.location.pathname.slice(window.location.pathname.indexOf("https"), window.location.pathname.length))
  const assignmentLink = window.location.pathname.slice(window.location.pathname.indexOf("https"), window.location.pathname.length);
  const assignmentData = submittedAssignments.filter((values) => values.assignment_link === assignmentLink)
  console.log(assignmentData);
  const [score, setScore] = useState<number>(0);
  const [studentId] = useState<string>(assignmentData[0].student_id);
  const [link] = useState<string>(assignmentData[0].assignment_link);
  const [scoreError, setScoreError] = useState<string>("");

  const testNum = /^\d*\.?\d+$/;
  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (typeof score !== "number" || isNaN(score)) {
      return setScoreError("Not a number")
    }
    setScoreError("");
    if (studentId === "") {
      return Swal.fire({
        icon: "error",
        text: "StudentID is empty"
      });
    }
    if (link === "") {
      return Swal.fire({
        icon: "error",
        text: "Assignment link is empty"
      });
    }
    const data = {score: score, studentId: studentId, assignmentLink: link};
    dispatch(gradeAssignment(teacherToken, data))
  }

  useEffect(() => {
    dispatch(getSubmittedAssignments(teacherToken));
  }, [])

  return (
    <Flex m={7} p={7} flexDirection={'column'} bgColor={"white"} boxShadow="2xl" borderRadius={"30px"}>
      <Text textTransform={"capitalize"} fontWeight={"bold"} fontSize={"2xl"}>Grade Assignment</Text>
      <Flex flexDirection={'column'} w={{ base: "100%", lg: "70%" }}>
        <form onSubmit={(e) => handleSubmit(e)}>
          <FormControl isInvalid={scoreError !== ""}>
            <FormLabel htmlFor="score" fontWeight={"bold"}>Score</FormLabel>
            <Input type="number" id="name" placeholder="name" value={score} onChange={(e) => setScore(parseInt(e.target.value))} required />
            <FormErrorMessage>{scoreError}</FormErrorMessage>
          </FormControl>
          <FormControl d="none">
            <FormLabel htmlFor="studentID">Student ID</FormLabel>
            <Input id="studentID" placeholder="studentID" value={assignmentData[0].student_id} required disabled />
          </FormControl>
          <FormControl d="none">
            <FormLabel htmlFor="name">Assignment Link</FormLabel>
            <Input id="link" placeholder="link" value={assignmentData[0].assignment_link} required disabled />
          </FormControl>
          <br />
          <Button type="submit" bgColor="red.400">Send</Button>
        </form>
      </Flex>
    </Flex>
  )
}

export default GradeAssignment
